export default __webpack_public_path__ + "static/media/Sume_AndresBahamon.16583dc4.png";